<template>
    <div>
      <!-- <el-button type="primary" size="small" style="margin: 10px 5px" @click="SureUpload">确认上传</el-button>
      <p v-if="fileList.length > 0" style="margin: 5px 5px;color:#909399 ;">如果上传信息无误后,请点击确认上传后在进行下面操作</p> -->
      <el-upload ref="myUpload" action="#" :list-type="type" :auto-upload="false" :limit="limit" :file-list="filearr"
        :on-change="OnChangeUpload" :on-exceed="handleExceed" multiple :on-progress="onProgress" :disabled="Isdisabled"
        :class="{ disUoloadSty: noneBtnDealImg }"
        style="width: 95%;border: 2px solid #DCDFE6;padding: 15px 5px 10px;min-width: 165px;" :apiType="apiType"
        :on-remove="handleRemove" :show-file-list="false">
        <el-button v-if="type == 'text' || type == 'video'" size="small" type="primary">点击上传</el-button>
        <i slot="default" class="el-icon-plus" v-else></i>
  
        <div slot="file" slot-scope="{file}" style="width: 100%;height: 100%;" v-if="type == 'img'">
          <el-image class="el-upload-list__item-thumbnail" :src="file.url" alt="" fit="fill"
            style="width: 100%;height: 100%;" :preview-src-list="scrList"></el-image>
          <span class="el-upload-list__item-actions">
            <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <!-- <span v-if="!disableds" class="el-upload-list__item-delete" @click="handleDownload(file)">
              <i class="el-icon-download"></i>
            </span> -->
            <span v-if="!disableds" class="el-upload-list__item-delete" @click="handleRemove(file)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
  
        </div>
        <div style="width: 100%;" v-if="type == 'text' && fileList.length > 0">
          <div v-for="(file, index) in  fileList" style="margin: 10px 0;">
            <el-button type="primary" icon="el-icon-mic" circle style="display: inline-block;color: red;"></el-button>
            <el-button type="text"
              style="margin-left: 35px;display: inline-block;color: red;width: 50%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              @click="$emit('titleClick')">
              {{ file.name }}
            </el-button>
            <el-button type="text" style="margin-left: 35px;display: inline-block;"
              @click.capture.stop="handleRemove(file)" v-if="file.name != ''">
              删除
            </el-button>
          </div>
  
        </div>
        <div style="width: 100%;" v-if="type == 'video' && videofileList.length > 0">
          <div v-for="(file, index) in  videofileList" :key="index"
            style="width: 100%;height:250px;overflow: hidden;position: relative;">
            <video controls :src="file.url" style="width: 100%;height: 100%;"></video>
            <div style="width: 50px;height: 50px;background-color:rgba(255, 5, 5,0.5);line-height: 50px;text-align: center;
                border-radius: 100%;font-size: 23px;color: white;position:absolute;top: -15px;right: -15px;"
              @click.capture.stop="handleRemove2(file.url)" v-if="file.url != ''">
              ✖
            </div>
          </div>
        </div>
      </el-upload>
  
      <!-- <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt=""> -->
      <el-image ref="scrImg" id="scrimg" :src="dialogImageUrl" alt="" fit="fill" style="width: 100%;height: 0;"
        :preview-src-list="scrList"></el-image>
      <!-- </el-dialog> -->
    </div>
  </template>
  
  <script>
  
  import { uploadAliyunFile, getIdCardInfo } from "../../api/api"
  export default {
    name: 'myUpload',
    components: {
  
    },
    props: {
      apiType: {
        default: "img"
  
      },
      filearr: {
        type: Array,
      },
      limit: {
        type: Number,
        default: 1
      },
      type: {
        type: String,
        default: "picture-card",
      },
    },
    data() {
      return {
        videofileList: [],
        maxLength: 0,
        loadings: '',
        dialogVisible: false,
        dialogImageUrl: '',
        noneBtnDealImg: false,
        Isdisabled: false,
        disableds: false,
        accessoryList: [],
        fileList: [],
        scrList: [],
      }
    },
    watch: {
      filearr: {
        handler(n, v) {
          // n.forEach((item,index)=>{
          //   const s ={
          //     name:item,
          //     uid:index,
          //     url:item
          //   }
          //   this.fileList.push(s)
          // })
  
          console.log(n);
          this.fileList = n;
          if (this.type == 'video') {
            this.videofileList = n;
          }
          if (this.fileList.length == this.limit) {
            this.Isdisabled = true;
            this.noneBtnDealImg = true;
          } else {
            this.Isdisabled = false;
            this.noneBtnDealImg = false;
          }
  
        },
        // 该回调将会在侦听开始之后被立即调用
        immediate: true,
        //该回调会在任何被侦听的对象的 property 改变时被调用，不论其被嵌套多深
        deep: true
  
      },
      fileList(n) {
        //console.log('fileList', n);
        if (this.fileList.length == this.limit) {
          this.Isdisabled = true;
          this.noneBtnDealImg = true;
        } else {
          this.Isdisabled = false;
          this.noneBtnDealImg = false;
        }
      }
    },
  
    created() { },
    methods: {
      MoveTheCloud(file) {
        return new Promise((resolve, reject) => {
          var s3 = new AWS.S3({
            apiVersion: '2006-03-01',
            accessKeyId: "1U04U6B1SL3IJNAOIAMN",
            secretAccessKey: "qUj578mhXovjWGXQi3BiooJ9YQd5Ded0sfvQGWx4",
            endpoint: "http://eos-shanghai-2.cmecloud.cn",
            signatureVersion: 'v2',
            sslEnabled: false
          });
          if (file) {
            //console.log(file);
            const fileName = file.uid + file.lastModified
            const fileType = file.name.split('.')
            //console.log(fileType);
            var params = {
              Key: "file/" + fileName + '.' + fileType[fileType.length - 1],
              Bucket: "aojv",
              ContentType: file.type,
              ACL: "public-read",
              Body: file
            }
            s3.putObject(params, function (err, data) {
              //console.log(err,data);
              if (err) return alert('重新错误,请重新上传');
              const fileUrl = 'http://aojv.eos-shanghai-2.cmecloud.cn/file/' + fileName + '.' + fileType[fileType.length - 1]
              const fileobj = {
                fileName: file.name,
                fileurl: fileUrl
              }
              //console.log(fileobj);
              return resolve(fileobj)
              // results.innerHTML = err ? 'ERROR!' : 'UPLOADED.';
              //http://aojv.eos-shanghai-2.cmecloud.cn/file/chenjingtest1001.aac      
            });
          } else {
            alert('重新上传');
          }
        })
  
      },
      fileAllRemove() {
        this.$nextTick(() => {
          this.$refs.myUpload.clearFiles()
          this.Isdisabled = false;
          this.noneBtnDealImg = false;
          this.fileList = []
          //console.log(this.fileList);
        })
  
      },
      openLoading() {
        //loading请求等待
        this.loadings = this.$loading({
          lock: true,
          text: "加载中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
      },
      async SureUpload() {
  
        const data = [];
        let Data = new FormData();
        if (this.apiType == 'cardUp') {
          this.accessoryList.forEach((item, index) => {
            if (item.raw) {
              Data.append("file", item.raw);
              Data.append("idCardType", 1)
              data.push(getIdCardInfo(Data));
            }
          });
          this.openLoading()
          const res = await Promise.all(data);
          const url = [];
          res.forEach((item, index) => {
            url.push(item.data)
          })
          //console.log(url);
          this.loadings.close()
          this.$emit('fileChange', url)
        } else if (this.apiType == 'cardDown') {
          this.accessoryList.forEach((item, index) => {
            if (item.raw) {
              Data.append("file", item.raw);
              Data.append("idCardType", 2)
              data.push(getIdCardInfo(Data));
            }
          });
  
          this.openLoading()
          const res = await Promise.all(data);
          const url = [];
          res.forEach((item, index) => {
            url.push(item.data)
          })
          //console.log(url);
          this.loadings.close()
          this.$emit('fileChange', url)
        } else {
          this.accessoryList.forEach((item, index) => {
            if (item.raw) {
              //console.log(item);
              Data.append("file", item.raw);
              data.push(uploadAliyunFile(Data));
              // data.push(uploadAliyunFile(item.raw));
            }
          });
          this.openLoading()
          const res = await Promise.all(data);
          //console.log(res);
          const url = [];
          res.forEach((item, index) => {
            url.push(item.data)
          })
          console.log(url);
          if (this.type == 'video') {
            const video = {
              url,
              uid: url
            }
            this.videofileList.push(video)
          }
          this.loadings.close()
          this.$emit('fileChange', url)
        }
      },
      uploadbf(file) {
        //console.log(file);
      },
      onProgress(event, file, fileList) {
        //console.log(event, file, fileList);
      },
      // 检验文件
      uploadFilesVerification(file, fileList) {
        let existFile = fileList.slice(0, fileList.length - 1).find((f) => f.name === file.name);
        if (existFile) {
          this.$message.error('当前文件已经存在!');
          fileList.pop();
          return
        }
        this.accessoryList = fileList;
        this.fileList = fileList;
        this.SureUpload(file, fileList)
        console.log(fileList, this.fileList,);
      },
      async OnChangeUpload(file, fileList) {
        console.log(fileList);
        let length = fileList.length;
        this.maxLength = Math.max(length, this.maxLength);
        setTimeout(() => {
          if (length === this.maxLength) {
            //console.log(this.maxLength);
            this.uploadFilesVerification(file, fileList)
          }
        }, 100)
      },
      handleRemove2(file) {
        console.log(file);
        this.videofileList = [];
        this.fileList = [];
        this.$emit('removeAfter', file)
      },
      handleRemove(file) {
        //console.log(file);
        const url = this.fileList.findIndex(item => item.url === file.url)
        const uid = this.fileList.findIndex(item => item.uid === file.uid)
  
        if (url) {
          //console.log('2');
          this.fileList.splice(url, 1)
          this.$emit('removeAfter', file.url)
          return
        } else {
          //console.log('1');
          this.fileList.splice(uid, 1);
          this.$emit('removeAfter', file.url)
          return
        }
      },
      handlePictureCardPreview(file) {
        //console.log(this.$refs.scrImg);
        this.dialogImageUrl = file.url;
        this.fileList.forEach(item => {
          this.scrList.push(item.url)
        })
        this.$refs.scrImg.clickHandler()
      },
      handleDownload(file) {
        //console.log(file);
      },
      //限制上传附件
      handleExceed(files, fileList) {
        //console.log(files);
        const val = this.limit - this.fileList.length
        if (val < files.length) {
          this.$message.warning(`当前限制选择 ${this.limit} 个文件，一共选择了 ${files.length + this.fileList.length} 个文件`)
          return
        }
        const size = files.size / 1024 / 1024;
        if (files.length > this.limit) {
          this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件`)
          return
        }
        if (size > 5) {
          this.$message.warning("文件大小不得超过5M");
          return;
        }
  
      },
  
    }
  }
  </script>
  
  <style scoped>
  .disUoloadSty /deep/ .el-upload--picture-card {
    display: none;
    /* 上传按钮隐藏 */
  }
  
  div /deep/ .el-upload {
    display: block !important;
  }
  </style>
  